import CardsContainer from './CardsContainer';

export default CardsContainer;
